import { render, staticRenderFns } from "./navigation-menu-link.vue?vue&type=template&id=528e6b75&"
import script from "./navigation-menu-link.vue?vue&type=script&lang=js&"
export * from "./navigation-menu-link.vue?vue&type=script&lang=js&"
import style0 from "./navigation-menu-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports